"use client";

import { usePathname } from "next/navigation";

const FOOTER_HIDDEN_PATHS: string[] = [];

export function ConditionalFooter({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (FOOTER_HIDDEN_PATHS.some((p) => pathname.startsWith(p))) return null;
  return <>{children}</>;
}
